<a *ngIf="isExternal; else localLink"
  (click)="clickAction()"
  target="_blank"
  routerLinkActive="jump-nav_list-item--selected">
  <span class="nav-icon-mobile">
    <mat-icon>{{ iconName }}</mat-icon>
  </span>
  <span class="nav-text" *ngIf="isOpened">
    {{ text }}
  </span>
</a>

<ng-template #localLink>
  <ng-container *ngIf="isSimpleLocal; else specialCase">
    <a (click)="clickAction()"
       class="jump-nav_list-item-link"
       routerLinkActive="jump-nav_list-item--selected">
       <span class="nav-icon-mobile">
        <mat-icon>{{ iconName }}</mat-icon>
      </span>
       <span class="nav-text" *ngIf="isOpened">
        {{ text }}
       </span>
    </a>
  </ng-container>
</ng-template>

<ng-template #specialCase>
  <a (click)="clickAction()"
     class="jump-nav_list-item-link"
     routerLinkActive="jump-nav_list-item--selected">
     <span class="nav-icon-mobile">
      <mat-icon>{{ iconName }}</mat-icon>
    </span>
     <span class="nav-text" *ngIf="isOpened">
      {{ text }}
    </span>
  </a>
</ng-template>
